import {
  slab, wallX, wallZ, goal, shard, sign, neon, checkpoint, edgeLights,
  fizzler, hazard, mover, lift,
} from '../kit.js';

const ledge = (x, y, z, w = 9, d = 9, m = 'plate') => [
  slab(x, y, z, w, d, m, 1.0),
  ...edgeLights(x, y, z, w, d, 'amber'),
];

/**
 * The uplink trick under pressure. Same central drop, but the shards sit
 * behind moving platforms, live grids and a fizzler alcove you have to reach
 * on carried speed alone.
 */
export default {
  id: 'spire',
  name: 'THE SPIRE',
  blurb: 'Six shards. One shaft. Do not touch the grids.',
  mode: { type: 'collect', par: 210 },
  redline: { seconds: 189 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 26], yaw: 0 },
  killY: -240,
  env: {
    fog: 0x180b26,
    fogDensity: 0.0034,
    sky: { zenith: 0x06030f, horizon: 0x210c33, glow: 0x6e1a86, aurora: 0x2a6fb0 },
    floorY: -360,
  },
  objects: [
    // ---- ring deck at ground level, portalable all the way round
    slab(0, 0, -24, 68, 20, 'panel', 1.4),
    slab(0, 0, 24, 68, 20, 'panel', 1.4),
    slab(-24, 0, 0, 20, 28, 'panel', 1.4),
    slab(24, 0, 0, 20, 28, 'panel', 1.4),
    ...edgeLights(0, 0, -24, 68, 20, 'cyan'),
    ...edgeLights(0, 0, 24, 68, 20, 'cyan'),

    // outer parapet
    wallZ(0, 0, -34.7, 70, 6, 'plate', 1.4),
    wallZ(0, 0, 34.7, 70, 6, 'plate', 1.4),
    wallX(-34.7, 0, 0, 70, 6, 'plate', 1.4),
    wallX(34.7, 0, 0, 70, 6, 'plate', 1.4),

    // ---- the shaft
    wallZ(0, -100, -14.75, 30, 100, 'plate', 1.5),
    wallZ(0, -100, 14.75, 30, 100, 'plate', 1.5),
    wallX(-14.75, -100, 0, 28, 100, 'plate', 1.5),
    wallX(14.75, -100, 0, 28, 100, 'plate', 1.5),
    slab(0, -100, 0, 29, 29, 'panel', 1.5),
    neon(0, -99.4, 0, [27, 0.18, 0.18], 'magenta'),
    neon(-13.9, -50, -13.9, [0.18, 98, 0.18], 'cyan'),
    neon(13.9, -50, 13.9, [0.18, 98, 0.18], 'cyan'),
    neon(-13.9, -50, 13.9, [0.18, 98, 0.18], 'magenta'),
    neon(13.9, -50, -13.9, [0.18, 98, 0.18], 'magenta'),

    // ---- the climb
    ...ledge(-22, 18, -20, 10, 10),
    shard(-22, 20, -20),
    hazard(-22, 18.3, -12, 10, 4),

    ...ledge(20, 30, 18, 10, 10),
    shard(20, 32, 18),

    mover(-2, 42, -28, [-2, 42, 28], [9, 0.8, 9], 9),
    ...ledge(-26, 46, 6, 10, 10),
    shard(-26, 48, 6),

    // fizzler alcove: portals die at the threshold, so arrive already moving
    ...ledge(26, 58, -14, 12, 12),
    fizzler(20.2, 58, -14, 9, 6, 90),
    shard(29, 60, -14),
    sign(26, 63, -8, 0, ['FIZZLER', 'PORTALS DIE HERE'], '#ff8a1f'),

    ...ledge(-8, 70, 26, 11, 11),
    shard(-8, 72, 26),
    hazard(-8, 70.3, 18, 11, 4),

    lift(4, 74, -22, 22, 3.0),
    ...ledge(4, 74, -22, 10, 10),

    ...ledge(4, 96, -22, 12, 12),
    shard(4, 98, -22),

    // ---- exit terrace
    slab(-18, 90, -30, 18, 18, 'plate', 1.2),
    ...edgeLights(-18, 90, -30, 18, 18, 'lime'),
    wallZ(-18, 90, -38.6, 19, 8, 'plate', 1.2),
    checkpoint(-18, 90, -24),
    goal(-18, 90, -34, 0),

    // ---- guidance
    sign(0, 3.4, 20, 0, [
      'THE SPIRE',
      'THE DECK AND THE SHAFT FLOOR TAKE PORTALS',
      'SIX SHARDS, THEN THE GATE',
    ]),
    sign(0, 2.2, -10, 0, ['100 METRE DROP'], '#ff2fd0'),
  ],
};
